import axios from 'axios';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';

const JEA_YEAR = 2020;

export const defaultState = {
  jea2020: {
    list: [],
    listLoading: false,
  },
};

export const mutations = {
  JEA2020_SET_LIST(state, list) {
    state.jea2020.list = list;
  },
  JEA2020_SET_LIST_LOADING(state, isLoading) {
    state.jea2020.listLoading = isLoading;
  },
};

export const getters = {
  getJea2020List: state => state.jea2020.list,
  getJea2020ListIsLoading: state => state.jea2020.listLoading,
};

export const actions = {
  // eslint-disable-next-line no-unused-vars
  callJea2020Approve({ dispatch }, data) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/approve`, data)
      .then(result => result.data);
  },
  // eslint-disable-next-line no-unused-vars
  callJea2020Trigger({ dispatch }, data) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/trigger`, data)
      .then(result => result.data);
  },
  fetchJea2020List({ commit }, filterByStatus) {
    commit('JEA2020_SET_LIST_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea?filter_by_status=${filterByStatus}`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { jeas } = response;
          commit('JEA2020_SET_LIST_LOADING', false);
          commit('JEA2020_SET_LIST', jeas);
        });
      })
      .catch((error) => {
        commit('JEA2020_SET_LIST_LOADING', false);
        commit('JEA2020_SET_LIST', []);

        return Promise.reject(error);
      });
  },
  fetchJea2020All({ dispatch }, filterByStatus) {
    dispatch('fetchJea2020List', filterByStatus);
  },
  // eslint-disable-next-line no-unused-vars
  fetchJea2020DownloadPdf({ commit }, requestData) {
    const { id } = requestData;

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/pdf/${id}`)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
};

const jea2020 = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default jea2020;



// WEBPACK FOOTER //
// ./src/store/payout/jea2020.js